module.exports = __webpack_public_path__ + "img/other-app-phone.3f379eda.svg";